module.exports = __webpack_public_path__ + "static/img/home_new2.cac4baf5.jpg";